import { Routes, Route } from 'react-router-dom';
import Layout from '@/components/Layout';
import Dashboard from '@/pages/Dashboard';
import Clients from '@/pages/Clients';
import ClientForm from '@/pages/ClientForm';
import ClientDetail from '@/pages/ClientDetail';
import { Maintenance } from '@/pages/Maintenance';
import MaintenanceForm from '@/pages/MaintenanceForm';
import MaintenanceDetail from '@/pages/MaintenanceDetail';
import CCTV from '@/pages/CCTV';
import CCTVForm from '@/pages/CCTVForm';
import CCTVDetail from '@/pages/CCTVDetail';
import Users from '@/pages/Users';
import Settings from '@/pages/Settings';

export default function App() {
  return (
    <Routes>
      <Route path="/" element={<Layout />}>
        <Route index element={<Dashboard />} />
        <Route path="dashboard" element={<Dashboard />} />
        <Route path="clients" element={<Clients />} />
        <Route path="clients/new" element={<ClientForm />} />
        <Route path="clients/:id" element={<ClientDetail />} />
        <Route path="clients/:id/edit" element={<ClientForm />} />
        <Route path="maintenance" element={<Maintenance />} />
        <Route path="maintenance/new" element={<MaintenanceForm />} />
        <Route path="maintenance/:id" element={<MaintenanceDetail />} />
        <Route path="cctv" element={<CCTV />} />
        <Route path="cctv/new" element={<CCTVForm />} />
        <Route path="cctv/:id" element={<CCTVDetail />} />
        <Route path="users" element={<Users />} />
        <Route path="settings" element={<Settings />} />
      </Route>
    </Routes>
  );
}
